import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';

const NavTab = ({ match, to, selectedPaths, title, iconClassName, target, external }) => {
  let classes = ['nav-tab']
  let content;

  if (!selectedPaths) selectedPaths = [];
  if (selectedPaths.includes(match.path)) {
    classes.push('is-active');
  }

  if (external) {
    content = (
      <a
        href={ to }
        target={ target }>
        <span className="icon is-small">
          <i
            className={ iconClassName }
            aria-hidden="true" />
        </span>
        <span className="nav-tab--title">{ title }</span>
      </a>
    );
  } else {
    content = (
      <Link
        to={ to }
        target={ target }>
        <span className="icon is-small">
          <i
            className={ iconClassName }
            aria-hidden="true" />
        </span>
        <span className="nav-tab--title">{ title }</span>
      </Link>
    );
  }

  return (
    <li className={ classes.join(' ') }>
      { content }
    </li>
  );
}

export default withRouter(NavTab);


// WEBPACK FOOTER //
// ./src/components/nav-tab/nav-tab.js